export const renderNum = (num: number): string => {
    if (num === 1) {
        return "TBC";
    } else {
        return "£" + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
};
